import React from 'react';
import Wrapper from './Wrapper';

const Trophy = Wrapper(props => (
  <svg
    width="29"
    height="29"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9058 16.6315V19.6089"
      stroke="#343A40"
      strokeWidth="1.78646"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2226 24.0751C17.2762 21.3979 14.745 19.608 11.9055 19.608C9.06595 19.608 6.53478 21.3979 5.58838 24.0751H18.2226Z"
      stroke="#343A40"
      strokeWidth="1.78646"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3759 1.74435H20.0977C20.9199 1.74435 21.5864 2.41087 21.5864 3.23307V6.95485C21.5864 12.2991 17.2541 16.6315 11.9098 16.6315C6.56553 16.6315 2.23315 12.2991 2.23315 6.95485V3.23307C2.23315 2.41087 2.89967 1.74435 3.72187 1.74435H7.44365"
      stroke="#343A40"
      strokeWidth="1.78646"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4355 3.55364L13.6751 5.99315H15.7861C16.024 5.98734 16.241 6.12795 16.333 6.34738C16.4249 6.5668 16.3729 6.82015 16.202 6.98562L14.2637 8.88919L15.3375 11.3555C15.4346 11.5871 15.3729 11.8549 15.1842 12.0206C14.9955 12.1864 14.722 12.2131 14.5048 12.087L11.9095 10.627L9.31419 12.087C9.09701 12.2131 8.82354 12.1864 8.63485 12.0206C8.44617 11.8549 8.38444 11.5871 8.4815 11.3555L9.55536 8.88919L7.61706 6.98165C7.44612 6.81618 7.39412 6.56283 7.48606 6.34341C7.578 6.12398 7.79507 5.98337 8.03291 5.98918H10.1439L11.3835 3.55364C11.4839 3.35532 11.6872 3.2303 11.9095 3.2303C12.1318 3.2303 12.3352 3.35532 12.4355 3.55364Z"
      stroke="#343A40"
      strokeWidth="1.78646"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default Trophy;
